import { GridColumns } from '@mui/x-data-grid-pro'
import { VisualQualityControlDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import {
  getVisualQualityControls,
  removeVisualQualityControl,
  setVisualQualityControlFilters,
  updateVisualQualityControl,
} from '@state/reducers/visualQualityControlReducer'
import { VisualQualityControlTypeLabels } from '@utils/constants'
import VisualQualityControlForm from '../forms/VisualQualityControlForm'

export default function VisualQualityControlsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(setVisualQualityControlFilters({ includeInactive: false }))
    }
  }, [])

  const columns: GridColumns<VisualQualityControlDto> = useMemo(
    () => [
      { field: 'label', headerName: 'Libellé', width: 150 },
      {
        field: 'type',
        headerName: 'Type',
        width: 125,
        valueGetter: (params) =>
          VisualQualityControlTypeLabels[params.row.type],
      },
    ],
    [],
  )

  return (
    <BaseConfigTable<VisualQualityControlDto>
      columns={columns}
      selectRows={(state) => state.visualQualityControl.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(setVisualQualityControlFilters({ includeInactive: true }))
        return dispatch(getVisualQualityControls())
      }}
      deleteThunk={removeVisualQualityControl}
      toggleThunk={(id, isActive) =>
        updateVisualQualityControl({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setVisualQualityControlFilters({ page }))
        dispatch(getVisualQualityControls())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <VisualQualityControlForm
          editingVisualQualityControl={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="contrôle qualité visuel"
      resourcePrefix="le "
    />
  )
}
